import styled from "styled-components";
import { COLORS } from "../../../styles/constants.style";

export const EditParticipantWrapper = styled.div`
  .sendTextSMSNotifications {
    color: ${COLORS.cirrus_black7};
  }
`;
